import React from 'react';

export type CardHeader = {
  start?: React.ReactNode;
  center?: React.ReactNode;
  end?: React.ReactNode;
};

export const Card: React.FC<{
  header: CardHeader;
  footer?: React.ReactNode;
  children: React.ReactNode;
  backgroundColor: string;
  width: string;
  id?: string;
}> = ({ header, footer, children, backgroundColor, width, id }) => {
  return (
    <div
      id={id}
      style={{
        backgroundColor: '#FFFFFF',
        width,
        '--wds-color-border-light': '#FFFFFF80',
      }}
      className={`relative flex flex-col justify-stretch h-full overflow-hidden rounded-lg border border-solid border-slate-300 text-color-slate-950`}
    >
      <div className="flex items-center px-4 h-[46px] text-base gap-4 flex-shrink-0">
        <div className="flex items-center justify-start flex-grow gap-2 basis-1">
          {header.start}
        </div>
        {header.center ? (
          <div className="flex items-center justify-center grow-[2] gap-2 basis-10">
            {header.center}
          </div>
        ) : null}
        <div className="flex items-center justify-end flex-grow gap-2 basis-1">{header.end}</div>
      </div>
      <div className={`border-t border-solid w-full`} style={{ borderColor: '#DFE5EB' }} />
      <div style={{ backgroundColor }} className="w-full h-full flex-grow overflow-auto text-sm">
        {children}
      </div>
      {footer && (
        <div className="flex items-center justify-stretch h-12 px-4 text-lg border-t border-solid bg-white flex-shrink-0 h-[46px]">
          {footer}
        </div>
      )}
    </div>
  );
};
